import 'babel-polyfill';
import $config from '@/config';
import feathers from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
import auth from '@feathersjs/authentication-client';
import io from 'socket.io-client';
const socket = io($config.feathersServer, { transports: ['websocket'], upgrade: false });
const feathersClient = feathers()
  .configure(socketio(socket, { timeout: 10000 }))
  .configure(auth({ storage: window.localStorage, timeout: 10000 }));

export default feathersClient;
